import script from "./ChainsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChainsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChainsComponent.vue?vue&type=style&index=0&id=894131a8&lang=scss"

const __exports__ = script;

export default __exports__